import { combineReducers } from '@reduxjs/toolkit';
import uiReducer from './ui.reducers';
import translationReducers from './translation.reducers';
import userReducers from './user.reducers';
import authReducers from './auth.reducers';
import contentReducers from './content.reducers';
import businessModelReducers from './plans-business-model.reducers';
import pendingRequestsReducers from './pending-requests.reducer';
import reportsReducers from './reports.reducers';
import globalReducers from './global.reducer';
import balanceReducers from './balance.reducer';
import dashboardReducers from './dashboard.reducer';
import customerAccountReducers from './customer-accounts.reducers';
import companyReducers from './company.reducers';
import newAccountReducers from './new_accounts.reducers';
import benefitsReducer from './benefits.reducer';
import featureFlagsReducer from './feature-flags.reducer';
import systemSettingsReducer from './system-settings.reducer';
import paymentCategoriesReducer from './payment-categories.reducer';
import webhookMonitoringReducer from './webhook-monitoring.reducer';
import systemMessagesReducer from './system-messages.reducer';
import hyperMonitoringReducer from './hyper-monitoring.reducer';

const rootReducer = combineReducers({
	ui: uiReducer,
	translation: translationReducers,
	user: userReducers,
	auth: authReducers,
	content: contentReducers,
	businessModel: businessModelReducers,
	reports: reportsReducers,
	global: globalReducers,
	pendingRequests: pendingRequestsReducers,
	balance: balanceReducers,
	dashboard: dashboardReducers,
	customerAccount: customerAccountReducers,
	company: companyReducers,
	newAccount: newAccountReducers,
	benefits: benefitsReducer,
	featureFlags: featureFlagsReducer,
	systemSettings: systemSettingsReducer,
	paymentCategories: paymentCategoriesReducer,
	webhookMonitoring: webhookMonitoringReducer,
	systemMessages: systemMessagesReducer,
	hyperMonitoring: hyperMonitoringReducer,
});

export default rootReducer;
